
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
  }
})
export default class WSAPageTwo extends Vue {
  @Prop() model: any;
  formModel: WSAPageTwoModel;

  data() {
    return {
      formModel: null
    }
  }

  created() {
    this.formModel = {
      ...this.model,
      numberOfJobs: '1',
      numberOfActivities: '1',
      numberOfSportsPlayed: '1'
    }
  }

  get sports() {
    const options = [
      'Baseball',
      'Basketball',
      'Cross Country',
      'Football',
      'Gymnastics',
      'Golf',
      'Hockey',
      'Soccer',
      'Softball',
      'Swimming & Diving',
      'Tennis',
      'Track & Field',
      'Volleyball',
      'Wrestling'
    ];
    const results: SelectorItem[] = [];

    results.push({
      value: '',
      id: '',
      label: ''
    });

    options.forEach((state) => {
      results.push({
        value: state,
        id: state,
        label: state
      });
    });

    return results;
  }

  @Emit('nextPage')
  async submitHandler() {
    return { ...this.formModel };
  }

  @Emit('previousPage')
  async handlePreviousClick() {
    return { ...this.formModel };
  }
}
